import { render, staticRenderFns } from "./CompanyTabHiring.vue?vue&type=template&id=380c89ec&scoped=true&"
import script from "./CompanyTabHiring.vue?vue&type=script&lang=js&"
export * from "./CompanyTabHiring.vue?vue&type=script&lang=js&"
import style0 from "./CompanyTabHiring.vue?vue&type=style&index=0&id=380c89ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380c89ec",
  null
  
)

export default component.exports